import React from 'react';
import PropTypes from 'prop-types';

const PhoneNumberInput = React.forwardRef(
    (
        {
            value,
            placeholder,
            containerClassName,
            className,
            containerRef,
            onChange,
            onKeyUp,
            onBlur,
            onClick,
        },
        ref
    ) => {
        return (
            <div
                className={`${containerClassName} m2g-list-cell m2g-list-cell--text-input`}
                data-icon-before
                role="presentation"
                onClick={onClick}
                ref={containerRef}
            >
                <span className="m2g-list-cell__icon m2g-icon" />
                <input
                    data-phone-number
                    type="tel"
                    name="phone"
                    autoComplete="tel"
                    className={`${className} m2g-list-cell__input`}
                    placeholder={placeholder}
                    value={value}
                    onChange={e => onChange && onChange(e.target.value)}
                    onKeyUp={onKeyUp}
                    onBlur={onBlur}
                    ref={ref}
                />
                <span className="m2g-list-cell__icon m2g-list-cell__icon--left m2g-icon m2g-icon--phone" />
            </div>
        );
    }
);

PhoneNumberInput.propTypes = {
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    containerRef: PropTypes.func,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
};

PhoneNumberInput.defaultProps = {
    placeholder: '',
    containerClassName: '',
    className: '',
    containerRef: undefined,
    onChange: undefined,
    onKeyUp: undefined,
    onBlur: undefined,
    onClick: undefined,
};

export default PhoneNumberInput;
